import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class PackBoxService {
    constructor(private http: HttpClient) {}

    getPackBoxListWithHierarchy() {
        return this.http.get<any>(
            `${environment.inventoryURl}PackBox/GetAllPackBoxWithHierarchy`
        );
    }

    deletePackBox(id) {
        return this.http.delete<any>(`${environment.inventoryURl}PackBox/${id}`);
    }

    addPackBox(data) {
        return this.http.post<any>(`${environment.inventoryURl}PackBox`, data);
    }

    updatePackBox(data) {
        return this.http.put<any>(`${environment.inventoryURl}PackBox`, data);
    }
}
